module.exports = __webpack_public_path__ + "files/907b6d4b90f418a5c373c3bbd2c5398e.svg";